import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges, OnChanges } from '@angular/core';

@Directive({
  selector: '[contenteditableModel]',
})
export class ContenteditableModelDirective implements OnChanges {
  @Input() contenteditableModel: string;
  @Output() contenteditableModelChange = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.contenteditableModel && !changes.contenteditableModel.firstChange) {
      this.elementRef.nativeElement.innerText = this.contenteditableModel;
    }
  }

  @HostListener('input')
  onInput() {
    const value = this.elementRef.nativeElement.innerText;
    this.contenteditableModelChange.emit(value);
  }
}


// WEBPACK FOOTER //
// ./src/app/guest-list/content-editable-modal.ts